import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";
import _  from 'underscore';
import "survey-react/survey.css";
 import "./testing.css"

class Testing1 extends Component {

  json = {
    // elements: [
    //  { type: "text", name: "customerName", title: "What is your name?", isRequired: true}
    // ]
  
      // pages: [
      //  {
      //   name: "page1",
      //   elements: [
      //    {
      //     type: "comment",
      //     name: "question1"
      //    },
      //    {
      //     type: "comment",
      //     name: "question2"
      //    },
      //    {
      //     type: "dropdown",
      //     name: "question3",
      //     choices: [
      //      "item1"
      //     ]
      //    }
      //   ]
      //  }
      // ]
      
      
      pages: [
        {
         name: "page1",
         elements: [
           {
            inputType: "text",
            name: "judge",
            placeholder: "judhjesy",
            required: true,
            title: "hydge",
            type: "text",
            validators: [
              {
               type: "email"
              }
             ],
           },
           {
            inputType: "date",
            name: "dateofbarth",
            placeholder: "Date of bithday",
            required: true,
            title: "judge",
            type: "text"
           },
          {
           type: "text",
           name: "question1",
           isRequired: true,
          
           inputType: "text",
           placeHolder: "judge love"
          },
          {
           type: "dropdown",
           name: "question7",
           choices: [
            "item1",
            "item2",
            "item3"
           ]
          },
          {
           type: "comment",
           name: "question8"
          }
         ]
        }
       ]
       
     
   };

  constructor(props){
    super(props)
    this.state = {
      noerorrpage :  true,
      complete: false,
      saving: false,
     };
     this.props.noerorrpage(this.state.noerorrpage)
    
    }

    onComplete(survey, options) {
      //Write survey results into database
      console.log("Survey results: " + JSON.stringify(survey.data));
      
     }

    



  render() {
    console.log("json data pass", this.json)
    var model = new Survey.Model(this.json);
    
    return (
                <div className="Home"> 
                      <div className="page-testing">
                           kjtbgjksretbfijk

                           <Survey.Survey model={model} onComplete={this.onComplete}/>
                      </div>
                      <ul class="tree">
    <li>Animals
     <ul>
      <li>Birds</li>
      <li>Mammals
       <ul>
        <li>Elephant</li>
        <li class="last">Mouse</li>
       </ul>
      </li>
      <li class="last">Reptiles</li>
     </ul>
    </li>
    <li class="last">Plants
     <ul>
      <li>Flowers
       <ul>
        <li>Rose</li>
        <li class="last">Tulip</li>
       </ul>
      </li>
      <li class="last">Trees</li>
     </ul>
    </li>
   </ul>



                </div>
            )
        }
    }    
  export default Testing1 ;      






// WEBPACK FOOTER //
// ./src/component/testing/testing1.js